<div class="modal-header justify-content-center">
    <h4 class="modal-title">{{'REM_CRDT_CONF_TEXT' | translate}}</h4>
</div>
<div class="modal-body text-center">{{ 'USER_PROFILE_REMOVE_ENROLLED_CARD' | translate }}</div>

<div class="modal-footer d-flex justify-content-center">
    <button class="btn btn-primary cta-blue info-btn" (click)="cancelAccountRemoval()">{{ 'OK' | translate }}</button>
</div>